import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Atalho } from '../../models/atalho';
import { FotoProvider } from '../../providers/foto/foto'

@Component({
  selector: 'atalho',
  templateUrl: 'atalho.html'
})
export class AtalhoComponent {

  @Input() atalho: Atalho;

  constructor(private fotoProvider: FotoProvider) {}

  public getUrlImagem(): string {
    const hash = this.atalho.hashImagem;
    if (hash !== "") {
      return this.fotoProvider.getUrlImagemServidor(hash);
    }
    return this.atalho.imagemLocal;
  }

}



// WEBPACK FOOTER //
// ./src/components/atalho/atalho.ts